import { render, staticRenderFns } from "./UpdateNotes.vue?vue&type=template&id=7cd44a52&"
import script from "./UpdateNotes.vue?vue&type=script&lang=js&"
export * from "./UpdateNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports